import { QueryClient, useQuery } from "@tanstack/react-query";

export const USER_PROFILE_QUERY_KEY = "user-profile-query";

export interface UserProfileDto {
  total_session_duration: number;
  session_duration_today: number;
}

export function useUserProfile(opts?: { enabled: boolean }) {
  const userProfileQuery = useQuery({
    queryKey: [USER_PROFILE_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const res = await fetch("/api/reeprise/profile/", { signal });
      if (!res.ok) {
        throw new Error("could not fetch user profile");
      }
      return (await res.json()) as UserProfileDto;
    },
    enabled: opts?.enabled,
  });

  return userProfileQuery;
}

export function invalidateQuery(client: QueryClient): void {
  client.invalidateQueries({ queryKey: [USER_PROFILE_QUERY_KEY] });
}
